import { createAction, props } from '@ngrx/store';
import { CompanyConfig, CompanyConfigDetailsDto } from '@floori/models';
import { Languages } from '@floori-web-components';

export const initConfig = createAction(
    '[Config] Init config',
    props<{ companyConfig: CompanyConfig; storedLang: Languages | null }>(),
);

export const loadConfigDetails = createAction('[Config] Load config details');

export const loadConfigDetailsSuccess = createAction(
    '[Config] Load config details success',
    props<{ configDetails: CompanyConfigDetailsDto }>(),
);

export const loadConfigDetailsFailure = createAction(
    '[Config] Load config details failure',
    props<{ error: unknown }>(),
);

export const changeLang = createAction('[Config] Change lang', props<{ lang: Languages }>());
